import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { GridWrapper } from '../../theme/Global'
import { hasPermission } from '../../account/selectors'
import CurrentWageMap from './currentWageMap'
import WageNotifications from './WageNotificationsWidget'
import EmploymentLawNewsWidget from '../../common/components/EmploymentLawNewsWidget'
import { isAppLoading } from '../../app/selectors'
import RenewalDateWidget from '../../common/components/RenewalDateWidget'
import AccountContact from '../../common/components/AccountContact/AccountContact'

const MinWageDashboardRenderer = (props) => {
  const { hasMinimumWage, blogPosts, renewDate, isLoading } = props

  if (!hasMinimumWage) {
    return (
      <GridWrapper>
        <Grid container spacing={40} direction="row" justify="center" alignItems="stretch">
          <Grid item xs={12}>
            <h3>Hard Time Tracking Minimum Wage Changes?</h3>
            <p>
              GovDocs Minimum Wage is a new web-based application that provides the most up-to-date
              minimum wage rate and related data for each of your U.S. locations and notifies you
              whenever wage changes occur.
            </p>
            <p>
              Want to learn more? Contact your GovDocs Customer Success Manager or Customer Service
              at 1-888-273-3274.
            </p>
          </Grid>
        </Grid>
      </GridWrapper>
    )
  }

  return (
    <GridWrapper>
      <Grid container spacing={40} direction="row" justify="center" alignItems="stretch">
        <Grid item xs={10} md={8}>
          <Grid item xs={12}>
            <CurrentWageMap />
          </Grid>
          <Grid item xs={12}>
            <EmploymentLawNewsWidget blogPosts={blogPosts} />
          </Grid>
        </Grid>
        <Grid item xs={10} md={4}>
          <Grid
            item
            xs
            style={{ margin: '0rem auto' }}
          >
            <WageNotifications />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <AccountContact type="minWagePaidLeave" cardBg />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <RenewalDateWidget
              isLoading={isLoading}
              renewDate={renewDate}
            />
          </Grid>
        </Grid>
      </Grid>
    </GridWrapper>
  )
}

const mapStateToProps = (state) => ({
  hasMinimumWage: hasPermission(state)('hasMinimumWage'),
  companyId: state.account.company._id,
  companyHasTippedEmployees: state.account.company.hasTippedEmployees,
  blogPosts: state.compliance.blogPosts.slice(0, 4),
  renewDate: state.account.company.minimumWage && state.account.company.minimumWage.renewDate ? state.account.company.minimumWage.renewDate : '',
  isLoading: isAppLoading(state)
})

MinWageDashboardRenderer.propTypes = { hasMinimumWage: PropTypes.bool.isRequired }

const MinWageDashboardComponent = compose(connect(mapStateToProps))(MinWageDashboardRenderer)

export default MinWageDashboardComponent
